import router from '@/_router';
import { useLocalStorage } from 'vue-composable';

const { storage: portalSlug } = useLocalStorage('_storiesonboard_portal_slug', '');

const setSlug = (productSlug: string, slug: string) => {
    portalSlug.value = slug;

    const pathToGo = `/${productSlug}/feedbackportal/p/${portalSlug.value}`;

    if (router.currentRoute.fullPath !== pathToGo) {
        router.replace(pathToGo);
    }
};

export const useIdeaPortalSlugStore = () => ({
    setSlug,
    portalSlug,
});
